<template>
<div>
<div class="title_comment midashi">
  <div>管理人のつぶやき</div>
</div>
  <!--吹き出しはじまり-->
  <div class="balloon5">
    <div class="faceicon">
      <img src="../image/my_icon.jpeg">
    </div>
    <div class="chatting">
      <div class="says">
        <p>競馬当ててApple Watchを買いたいです。</p>
      </div>
    </div>
  </div>
  <!--吹き出し終わり-->
  <!--吹き出しはじまり-->
  <div class="balloon5">
    <div class="faceicon">
      <img src="../image/my_icon.jpeg">
    </div>
    <div class="chatting">
      <div class="says">
        <p>栗東会議は安定しているなぁ〜。12月はアレだけど、いまのところ1月は好調ね。1/17の予想買ってみようかな</p>
      </div>
    </div>
  </div>
  <!--吹き出し終わり-->
</div>
</template>

<script>
export default {
    name: 'TabComment', 
  components: {
  },
  data () {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.title_comment {
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.midashi {
  font-size: 32px;
  color: #364e96;/*文字色*/
  padding: 0.5em 0;/*上下の余白*/
  border-top: solid 3px #364e96;/*上線*/
  border-bottom: solid 3px #364e96;/*下線*/
}

.balloon5 {
  width: 100%;
  margin: 1.5em 0;
  overflow: hidden;
}

.balloon5 .faceicon {
  float: left;
  margin-right: -90px;
  width: 80px;
}

.balloon5 .faceicon img{
  width: 100%;
  height: auto;
  border: solid 3px #d7ebfe;
  border-radius: 50%;
}

.balloon5 .chatting {
  width: 100%;
}

.says {
  display: inline-block;
  position: relative; 
  margin: 5px 0 0 105px;
  padding: 17px 13px;
  border-radius: 12px;
  background: #d7ebfe;
}

.says:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 18px; 
  left: -24px;
  border: 12px solid transparent;
  border-right: 12px solid #d7ebfe;
}

.says p {
  margin: 0;
  padding: 0;
}

</style>